module.exports = __webpack_public_path__ + "media/images/properties-6e91583136b683b865f96d473a6b04c7.svg";